











export default {
  name: "lef-icon",
  props: {
    title: {
      type: String,
      default: ""
    },
    decorative: {
      type: Boolean,
      default: false
    }
  }
}
